import {
  withTranslation,
} from 'react-i18next';

import RegattaBoatRentFieldsView from './RegattaBoatRentFieldsView';

const TranslatedComponent = withTranslation()(RegattaBoatRentFieldsView);

const Component = TranslatedComponent;

export default Component;
